import { Controller } from "@hotwired/stimulus"

//
//
// Connects to data-controller="dialog"

export default class extends Controller {
  dialogTargetConnected(element){
    const sibling = element.nextElementSibling
    if(!sibling.matches('[role="button"]')){
      return
    }
    if (!sibling.dataset['action']) {
      sibling.dataset['action'] = ''
    }
    sibling.dataset['action'] += 'click->dialog#openDialog'
    element.querySelectorAll('.btn, .close').forEach((btn) => {
      if (!btn.dataset['action']) {
        btn.dataset['action'] = ''
      }
      btn.dataset['action'] += 'click->dialog#closeDialog '
    })
  }

  closeDialog(event) {
    const dialog = event.target.closest('dialog')
    if(!dialog.matches('dialog')){
      return
    }
    dialog.close();
  }

  openDialog(event) {
    let anchor = event.target
    if(!anchor.matches('a')){
      anchor = event.target.closest('a')
    }
    const dialog = anchor.previousElementSibling
    if(!dialog.matches('dialog')){
      return
    }
    dialog.showModal();
    
    // Dispatch generic dialog:opened event
    dialog.dispatchEvent(new CustomEvent('dialog:opened', { bubbles: true }))
    
    event.preventDefault();
  }
}
